import api from './api';

export const artistApi = {
  // 슬러그로 아티스트 상세 조회 (sourceId/sourceType은 slug가 DB에 없을 때 폴백용)
  getArtistBySlug: async (slug, { sourceId, sourceType } = {}) => {
    const params = sourceId ? `?sourceId=${sourceId}&sourceType=${sourceType}` : '';
    const response = await api.getPublic(`/artists/by-slug/${slug}${params}`);
    return response.data;
  },

  // 아티스트 상세 조회
  getArtistById: async (artistSource, sourceId) => {
    const response = await api.getPublic(`/artists?id=${sourceId}&type=${artistSource}`);
    return response.data;
  },

  getAlbumsByType: async (artistSource, sourceId, albumType) => {
    const response = await api.getPublic(
      `/artists/${albumType}?id=${sourceId}&type=${artistSource}`,
    );
    return response.data;
  },

  getArtistViewByType: async (artistSource, sourceId, viewType) => {
    const response = await api.getPublic(
      `/artists/view/${viewType}?id=${sourceId}&type=${artistSource}`,
    );
    return response.data;
  },
};
